import { createFileRoute } from "@tanstack/react-router";
import AuditLogPage from "@/features-root-user/audit";
import { auditLogsQueryOptions } from "@/features-root-user/service/audit";
import { LoadingScreen } from "@/components/ui/loading-screen";

export const Route = createFileRoute("/_root/root-user/audit")({
  component: AuditLogPage,
  loader: ({ context: { queryClient } }) => {
    // Preload the first page of audit logs - removed await
    queryClient.ensureQueryData(
      auditLogsQueryOptions({ page: 1, pageSize: 10 }),
    );
  },
  pendingComponent: () => <LoadingScreen text="Loading..." />,
});
